(function () {
    'use strict';

    angular.module("imApp").factory("shiftDayService", ['$ihttp', function ($ihttp) {
        let service = {
            listShiftHours: function (parms) {
                return $ihttp.post({
                    method: 534,
                    parameters: parms || {}
                });
            },
            listShiftBreaks: function (parms) {
                return $ihttp.post({
                    method: 555,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
